"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var utils_1 = require("../utils/utils");
var constant_1 = require("../../constant");
var TUIAegis_1 = require("../../../../utils/TUIAegis");
var vuex_1 = require("vuex");
var common_1 = require("@/config/types/common");
var lodash_1 = require("lodash");
exports.default = vue_1.defineComponent({
    props: {
        data: {
            type: Object,
            default: function () { return ({}); },
        },
    },
    setup: function (props, ctx) {
        var _this = this;
        var _a, _b;
        var VuexStore = (((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.TUIKitTUICore) === null || _b === void 0 ? void 0 : _b.isOfficial) && vuex_1.useStore && vuex_1.useStore()) || {};
        var data = vue_1.reactive({
            data: {},
            extension: {},
            isCustom: "",
            constant: constant_1.default,
            customMessageType: common_1.CUSTOM_MESSAGE_TYPE,
            index: 0,
        });
        vue_1.watchEffect(function () {
            var _a;
            data.data = props.data;
            var payload = props.data.message.payload;
            data.isCustom = payload.data || " ";
            data.isCustom = utils_1.JSONToObject(payload.data);
            if (payload.data === constant_1.default.typeService) {
                data.extension = utils_1.JSONToObject(payload.extension);
            }
            // 生成随机背景色企业logo
            var companyId = (_a = data.isCustom) === null || _a === void 0 ? void 0 : _a.company_id;
            if (companyId && lodash_1.isNumber(+companyId)) {
                var num = +companyId;
                if (+companyId > Number.MAX_SAFE_INTEGER) {
                    num = +companyId.substring(companyId.length - 6);
                }
                data.index = +num % 6;
            }
        });
        var openLink = function (url) {
            window.open(url);
        };
        var handleCallMessageIcon = function () {
            var _a, _b, _c, _d, _e;
            var callType = (_e = JSON.parse((_d = JSON.parse((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.payload) === null || _c === void 0 ? void 0 : _c.data)) === null || _d === void 0 ? void 0 : _d.data)) === null || _e === void 0 ? void 0 : _e.call_type;
            var className = "";
            switch (callType) {
                case 1:
                    className = "icon-call-voice";
                    break;
                case 2:
                    className = "icon-call-video";
                    break;
                default:
                    break;
            }
            return className;
        };
        var handleCallAgain = function () { return __awaiter(_this, void 0, void 0, function () {
            var callType, _a, _b, flow, to, from, error_1;
            var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
            return __generator(this, function (_v) {
                switch (_v.label) {
                    case 0:
                        callType = (_g = JSON.parse((_f = JSON.parse((_e = (_d = (_c = props === null || props === void 0 ? void 0 : props.data) === null || _c === void 0 ? void 0 : _c.message) === null || _d === void 0 ? void 0 : _d.payload) === null || _e === void 0 ? void 0 : _e.data)) === null || _f === void 0 ? void 0 : _f.data)) === null || _g === void 0 ? void 0 : _g.call_type;
                        TUIAegis_1.default.getInstance().reportEvent({
                            name: "callOptions",
                            ext1: "clickCall",
                        });
                        _a = (_j = (_h = data === null || data === void 0 ? void 0 : data.data) === null || _h === void 0 ? void 0 : _h.message) === null || _j === void 0 ? void 0 : _j.conversationType;
                        switch (_a) {
                            case window.TUIKitTUICore.TIM.TYPES.CONV_C2C: return [3 /*break*/, 1];
                            case window.TUIKitTUICore.TIM.TYPES.CONV_GROUP: return [3 /*break*/, 6];
                        }
                        return [3 /*break*/, 7];
                    case 1:
                        _b = (_k = data === null || data === void 0 ? void 0 : data.data) === null || _k === void 0 ? void 0 : _k.message, flow = _b.flow, to = _b.to, from = _b.from;
                        if (to === from)
                            return [3 /*break*/, 8];
                        _v.label = 2;
                    case 2:
                        _v.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, ((_p = (_o = (_m = (_l = window) === null || _l === void 0 ? void 0 : _l.TUIKitTUICore) === null || _m === void 0 ? void 0 : _m.TUIServer) === null || _o === void 0 ? void 0 : _o.TUICallKit) === null || _p === void 0 ? void 0 : _p.call({
                                userID: flow === "out" ? to : from,
                                type: callType,
                            }))];
                    case 3:
                        _v.sent();
                        ((_r = (_q = window) === null || _q === void 0 ? void 0 : _q.TUIKitTUICore) === null || _r === void 0 ? void 0 : _r.isOfficial) && (VuexStore === null || VuexStore === void 0 ? void 0 : VuexStore.commit) && (VuexStore === null || VuexStore === void 0 ? void 0 : VuexStore.commit("handleTask", 6));
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _v.sent();
                        console.warn(error_1);
                        return [3 /*break*/, 5];
                    case 5:
                        if ((_u = (_t = (_s = window) === null || _s === void 0 ? void 0 : _s.TUIKitTUICore) === null || _t === void 0 ? void 0 : _t.TUIServer) === null || _u === void 0 ? void 0 : _u.TUICallKit) {
                            TUIAegis_1.default.getInstance().reportEvent({
                                name: "callOptions",
                                ext1: "clickCall-success",
                            });
                            TUIAegis_1.default.getInstance().reportEvent({
                                name: "callOptions",
                                ext1: "call-c2c",
                            });
                        }
                        return [3 /*break*/, 8];
                    case 6: return [3 /*break*/, 8];
                    case 7: return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        // 职位详情页
        var toJobDetail = function () {
            var _a;
            window.open(process.env.VUE_APP_HOST + "/job/detail?id=" + ((_a = data.isCustom) === null || _a === void 0 ? void 0 : _a.job_id));
        };
        // 单位主页
        var toCompanyDetail = function () {
            var _a;
            window.open(process.env.VUE_APP_HOST + "/company?id=" + ((_a = data.isCustom) === null || _a === void 0 ? void 0 : _a.company_id));
        };
        return __assign(__assign({}, vue_1.toRefs(data)), { isUrl: utils_1.isUrl,
            openLink: openLink,
            handleCallMessageIcon: handleCallMessageIcon,
            handleCallAgain: handleCallAgain,
            toJobDetail: toJobDetail,
            toCompanyDetail: toCompanyDetail });
    },
});
